import React, { useState } from "react";
import { sendPushNotification } from "../api/common.api";
import { PushType } from "../types/type";
import { usePushNotificationForm } from "../hooks/usePushNotificationForm";

interface PushNotificationFormManyProps {
  tokens: string[]; // 유저 대신 토큰 배열을 받음
}

const PushNotificationFormMany: React.FC<PushNotificationFormManyProps> = ({
  tokens,
}) => {
  const {
    title,
    setTitle,
    content,
    setContent,
    screen,
    handleScreenChange,
    type,
    handleTypeChange,
    songId,
    handleSongIdChange,
    songIdError,
    setSongIdError,
    validateSongId,
  } = usePushNotificationForm();

  const handleSendNotification = async () => {
    let valid = true;

    if (!validateSongId(songId)) {
      setSongIdError(
        "SongId는 00000에서 99999 사이의 5자리 숫자 문자열이거나 '0', '-1'이어야 합니다."
      );
      valid = false;
    } else {
      setSongIdError("");
    }

    if (!title || !content || tokens.length === 0) return;

    const body = {
      title,
      body: content,
      tokenList: tokens,
      data: {
        songTitle: "custom",
        screen: screen,
        type: type,
        songId: "0",
      },
    };

    try {
      await sendPushNotification(body);
    } catch (error) {
      console.error("Failed to send push notification:", error);
    }
  };

  return (
    <div>
      <div className="notification-form">
        <div className="input-group">
          <label>
            Title:
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </label>
        </div>
        <div className="input-group">
          <label>
            Content:
            <textarea
              value={content}
              onChange={(e) => setContent(e.target.value)}
              style={{ width: "100%", height: "100px" }}
            />
          </label>
        </div>
        <div className="input-group">
          <label>
            SongId:
            <input
              type="text"
              value={songId}
              onChange={handleSongIdChange}
              style={{
                borderColor: songIdError ? "red" : "",
                borderWidth: songIdError ? "2px" : "1px",
              }}
            />
          </label>
          {songIdError && <div style={{ color: "red" }}>{songIdError}</div>}
        </div>
        <div>
          <label>
            Screen:
            <select value={screen} onChange={handleScreenChange}>
              <option value="Recent">Recent</option>
              <option value="MyBrewingList">MyBrewingList</option>
              <option value="Home">Home</option>
              <option value="My">My</option>
            </select>
          </label>
        </div>
        <div>
          <label>
            Type:
            <select value={type} onChange={handleTypeChange}>
              <option value="제조완료">제조완료</option>
              <option value="곡업데이트">곡업데이트</option>
            </select>
          </label>
        </div>
      </div>
      <button onClick={handleSendNotification}>알림 보내기</button>
    </div>
  );
};

export default PushNotificationFormMany;
